const LK_Select =({color,width,height})=>{
    return(
        <svg id="Layer_1" data-name="Layer 1" fill={color} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 116.99 116.99">
        {/* <defs>
            <style>
            .cls-1 {
                fill: #005c8e;
                stroke-width: 0px;
            }
            </style>
        </defs> */}
        <polygon class="cls-1" points="4.33 57.37 0 57.37 0 77.99 20.62 77.99 20.62 73.66 4.33 73.66 4.33 57.37"/>
        <rect class="cls-1" y="30.85" width="4.33" height="16.29"/>
        <rect class="cls-1" x="30.85" y="73.66" width="16.29" height="4.33"/>
        <polygon class="cls-1" points="73.66 20.62 77.99 20.62 77.99 0 57.37 0 57.37 4.33 73.66 4.33 73.66 20.62"/>
        <rect class="cls-1" x="30.85" width="16.29" height="4.33"/>
        <rect class="cls-1" x="73.66" y="30.85" width="4.33" height="16.29"/>
        <polygon class="cls-1" points="0 20.62 4.33 20.62 4.33 4.33 20.62 4.33 20.62 0 0 0 0 20.62"/>
        <path class="cls-1" d="M100.73,92.1l-1.57-1.57-1.49-1.49-.63-.63,19.95-11.69-5.88-1.58-33.11-8.87v-8.9h-4.33v7.74l-11.68-3.13,3.13,11.68h-7.74v4.33h8.9l8.87,33.11,1.58,5.88,11.69-19.95.63.63,1.49,1.49,1.57,1.57,8.75,8.75c2.38,2.38,6.25,2.38,8.63,0l4.32-4.32-4.32-4.32-8.75-8.75ZM106.42,106.42c-.69.69-1.81.69-2.5,0l-4.11-4.11-4.64-4.64-1.57-1.57-1.49-1.49-1.43-1.43-.15-.15-3.02-3.02-2.26,3.86-6.28,10.72-.74,1.26-7.46-27.86-1.16-4.33-1.49-5.55,5.55,1.49,4.33,1.16,27.86,7.46-1.26.74-10.72,6.28-3.86,2.26,3.02,3.02.15.15,1.43,1.43,1.49,1.49,1.57,1.57,4.64,4.64,4.11,4.11,1.25,1.25-1.25,1.25Z"/>
        </svg>
    );
};

export default LK_Select;